module.exports = __webpack_public_path__ + "img/comments.668f88c5.png";